import React from 'react';
import PropTypes from 'prop-types';

import styles from './InputFieldsDiv.scss';

/* eslint-disable jsx-a11y/no-autofocus */
export default function InputDivWithNonEditable({
    onChange,
    nonEditableText,
    inputValue,
    dataField,
    inputSize,
    focused,
}) {
    return (
        <div className={styles['input-div-normal']}>
            <div className={styles['input-text-noneditable']}>
                {nonEditableText}
            </div>
            <input
                autoFocus={focused}
                type="text"
                value={inputValue}
                data-field={dataField}
                onChange={({ target }) => onChange(target.value)}
                className={styles[`input-field-hidden-${inputSize}`]}
            />
        </div>
    );
}
/* eslint-enable jsx-a11y/no-autofocus */

InputDivWithNonEditable.propTypes = {
    onChange: PropTypes.func.isRequired,
    nonEditableText: PropTypes.string.isRequired,
    inputValue: PropTypes.string.isRequired,
    dataField: PropTypes.string,
    inputSize: PropTypes.string,
    focused: PropTypes.bool,
};

InputDivWithNonEditable.defaultProps = {
    dataField: null,
    inputSize: 'large',
    focused: false,
};
